<script>
import axios from "axios";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import {WarehousePath} from '@/path';
import Locations from "./locations";
import Add from "./add.vue";

export default {
    components : {
    Layout,
    PageHeader,
    Locations,
    Add
},
    data(){
        return {
            title: "Warehouse",
            items: [
                {
                    text: "List",   
                },
                {
                    text: "Warehouse",
                    active: true,
                },
            ],
            warehouses : [],
            currentPage : 1,
            search : "",
            fields : ['id','name','locations','actions'],
            baseUrl : process.env.VUE_APP_API_BACKEND_URL,
            filter : [],
            selectedWarehouse : null,
        }
    },
    methods : {
        async getWarehouses(){
            try {
                let res = await axios.get(this.baseUrl + WarehousePath.Warehouses,{
                    params : {
                        page : this.currentPage,
                        search : this.search
                    }
                });
                if(res.data.status){
                    this.warehouses = res.data.data;
                }
            } catch (error) {
                console.log(error);
            }
        },
        openLocations(v){
            try {
                this.selectedWarehouse = v;
                this.$bvModal.show('locations-modal');
            } catch (error) {
                console.log(error);
            }
        },
        addWarehouse(){
            this.$bvModal.show('add-warehouse');
        },
        editWarehouse(v){
            this.selectedWarehouse = v;
            this.$bvModal.show('add-warehouse');
        }
    },
    mounted(){
        this.getWarehouses();
    }
}
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-card>
            <b-modal id="locations-modal" size="xl" title="Locations">
                <Locations :warehouse="selectedWarehouse"></Locations>
            </b-modal>
            <b-modal id="add-warehouse" size="xl" title="Warehouse" hide-footer>
                <Add :warehouse="selectedWarehouse"></Add>
            </b-modal>
            <b-button @click="addWarehouse"> + Add Warehouse</b-button>
            <div class="table-responsive mb-0">
                <b-table
                    :key="warehouses.key"
                    :items="warehouses.data"
                    :fields="fields"
                    responsive="sm"
                    :filter="filter"
                    :current-page="currentPage"
                >
                    <template v-slot:cell(locations)="row">
                        <b-button size="sm" @click="openLocations(row.item)"><i class="fa fa-list"></i></b-button>
                    </template>
                    <template v-slot:cell(actions)="row">
                        <b-button variant="secondary" class="mr-4" @click="editWarehouse(row.item)"><i class="fa fa-pen"></i></b-button>
                        <!-- <b-button variant="danger"><i class="fa fa-trash"></i></b-button> -->
                    </template>
                </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination :key="warehouses.key" v-model="currentPage" :total-rows="warehouses.total" :per-page="warehouses.per_page"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
        </b-card>
    </Layout>
</template>

<style>
    
</style>